import { SxProps } from '@mui/material'
import { TemplateColor } from './Calendar';

// const colorMeeting = '#ffc57a';
// const colorEvent = '#a6e745';

const StyleCalendar = ({ small }) => ({
    padding: small ? '0.5em' : '1em',
    backgroundColor: '#ffffff80',
    borderRadius: '1em',
    boxShadow: TemplateColor.BoxShadowDown,
    '.fc' : {
        minHeight : "80vh"
    },

    '.fc .fc-popover.fc-more-popover': {
        zIndex: 1100,

        '.fc-daygrid-event-harness': {
            maxWidth: '300px',
        },

        '.bg-type-meeting': {
            borderRadius: '0em 1em 1em 0em',
            borderLeft: `3px solid ${TemplateColor.MeetingDarkColor}`,
        },
        '.bg-type-event': {
            borderRadius: '0em 1em 1em 0em',
            borderLeft: `3px solid ${TemplateColor.EventDarkColor}`,
        },
    },

    '.fc-header-toolbar.fc-toolbar': {
        overflow: 'auto',
        ...(small ? { alignItems: 'flex-end', marginBottom: '0.5em' } : {})
    },


    '.fc-toolbar > div.fc-toolbar-chunk': {
        flex: '1',
    },

    '.fc-toolbar > div:nth-of-type(1)': { // Toolbar Left
        display: 'flex',
        justifyContent: 'flex-start',

        'button': {
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            border: 'none',
            backgroundColor: '#4b9aff',
            borderRadius: '2em',
            transition: 'all 300ms ease-in-out',
            ':hover': {
                backgroundColor: '#2b81ee',
            },
            ...(small ?
                { // small style
                    fontSize: '12px',
                    padding: '1px 8px',
                } :
                { // normall style
                    fontSize: '14px',
                    minWidth: '180px',
                })
        },
    },

    '.fc-toolbar > div:nth-of-type(2)': { // Toolbar Center
        display: 'flex',
        justifyContent: 'center',

        'div': {
            display: 'flex',
            columnGap: '10px',
            alignItems: 'center',

            '.fc-toolbar-title': { // Title
                color: '#4b9aff',
                textAlign: 'center',
                ...(small ?
                    { // small style
                        minWidth: '140px',
                        fontSize: '18px',
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'center',
                    } :
                    { // normall style
                        minWidth: '220px',
                        fontSize: '1.5em',
                    })

            },

            'button': {
                borderRadius: '50%',
                color: '#1d5ddf',
                border: 'none',
                backgroundColor: 'transparent',
                transition: 'all 300ms ease-in-out',
                ':hover': {
                    backgroundColor: '#eeeeee80',
                },
                ...(small ?
                    { // small style
                        fontSize: '8px',
                        padding: '4px',
                    } :
                    { // normall style
                        // minWidth: '200px',
                        fontSize: '12px',
                    })
            },
        },
    },
    '.fc-toolbar > div:nth-of-type(3)': { // Toolbar Right
        display: 'flex',
        justifyContent: 'flex-end',

        'div': {
            'button': {
                color: 'rgb(117, 117, 117)',
                border: 'none',
                backgroundColor: '#e6e6e6',
                transition: 'all 300ms ease-in-out',

                ...(small ?
                    { // small style
                        padding: '2px 0.7em',
                        fontSize: '12px',
                        minWidth: '30px',
                    } :
                    { // normall style
                        padding: '4px 4px',
                        minWidth: '70px',
                    }),

                ':first-of-type': {
                    borderTopLeftRadius: '2em',
                    borderBottomLeftRadius: '2em',
                },

                ':last-of-type': {
                    borderTopRightRadius: '2em',
                    borderBottomRightRadius: '2em',
                },
                ':hover': {
                    backgroundColor: '#eee',
                },
                '&.fc-button-active': {
                    color: 'white',
                    backgroundColor: '#4b9aff',
                    // color: '#4b9aff',
                    // backgroundColor: '#fcfcfc',
                    fontWeight: 'bold',
                }
            },
        },
    },

    // RESIZE
    'thead tr th': {
        'table.fc-col-header': { width: '100% !important' } // resize
    },
    'tbody tr td': {
        // resize
        '.fc-timegrid-body, .fc-daygrid-body': { width: '100% !important', 'table': { width: '100% !important' } },
    },


    '.fc-view.calendar-view': { // Box Day
        backgroundColor: '#ffffff80',
        ...(small ? { fontSize: '10px' } : {}),

        'table.fc-scrollgrid': {
            border: 'none',

            'th': {
                borderLeft: 'none',
                borderRight: 'none',
            },

            'tbody tr td': {
                borderLeft: '1px solid #ddd',
                '.fc-daygrid-day-number': small ? { padding: '0 4px' } : {},
            },
        },


        '.fc-daygrid-day-events': {
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: small ? 'row' : 'column',


            '.fc-daygrid-event-harness': {
                maxWidth: '100%',
            },

            '.event-item': {
                // cursor: 'pointer',
                // border: '0',
                // backgroundColor: 'transparent',

                '.small.type-event, .small.type-meeting': { fontSize: small ? '12px' : '24px', transition: 'all 300ms ease-in-out' },
                '.small.type-event': {
                    color: TemplateColor.EventColor,
                    ':hover': {
                        color: TemplateColor.EventHover
                    }
                },
                '.small.type-meeting': {
                    color: TemplateColor.MeetingColor,
                    ':hover': {
                        color: TemplateColor.MeetingHover
                    }
                },

                '.bg-type-meeting': {
                    borderRadius: '0em 1em 1em 0em',
                    borderLeft: `3px solid ${TemplateColor.MeetingDarkColor}`,
                },
                '.bg-type-event': {
                    borderRadius: '0em 1em 1em 0em',
                    borderLeft: `3px solid ${TemplateColor.EventDarkColor}`,
                },
            },

        },

        '.fc-timegrid-body': {
            '.fc-timegrid-event-harness': {
                width: '100%',
                left: '0px !important',
            },

            '.bg-type-meeting': {
                borderRadius: '0em 0em 1em 1em',
                borderTop: `3px solid ${TemplateColor.MeetingDarkColor}`,
            },
            '.bg-type-event': {
                borderRadius: '0em 0em 1em 1em',
                borderTop: `3px solid ${TemplateColor.EventDarkColor}`,
            },
        },


    },

    '.event-item': {
        cursor: 'pointer',
        border: '0',
        // borderRadius: '1em',
        backgroundColor: 'transparent',
        overflow: 'hidden',
        margin: '0',

        '.fc-event-main': {
            marginBottom: '4px',
            padding: '0',
            color: '#5a5d70',
        },
    },

    '.label-event': {
        cursor: 'pointer',
        wordBreak: 'break-all',
        maxHeight: '65px',
        lineHeight: '1.2',
        display: '-webkit-box',
        WebkitLineClamp: '4',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: small ? "8px" : '12px',
        padding: '1px',
    },
    '.arrow-label': {
        color: '#2279e0',
        verticalAlign: 'bottom',
        height: small ? '10px' : '16px',
        width: small ? '10px' : '12px',
        // marginTop: '4px'
    },

    '.bg-type-event, .bg-type-meeting': {
        height: '100%',
        cursor: 'pointer',
        transition: 'all 300ms ease-in-out',
    },
    '.bg-type-event': {
        backgroundColor: TemplateColor.EventColor,
        ':hover': {
            backgroundColor: TemplateColor.EventHover
        }
    },
    '.bg-type-meeting': {
        backgroundColor: TemplateColor.MeetingColor,
        ':hover': {
            backgroundColor: TemplateColor.MeetingHover
        }
    },


}) as SxProps





export default StyleCalendar;
